import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  fetchAceApplicationsData,
  fetchApplicationsData
} from 'features/applications/applicationsThunks';

import {
  Application,
  ApplicationsList,
  ApplicationsState
} from 'types/applications';

import { RequestStatus } from 'constants/enums';

const initialState: ApplicationsState = {
  applications: [],
  status: RequestStatus.Idle,
  error: null,
  count: 0
};

const applicationsSlice = createSlice({
  name: 'applications',
  initialState,
  reducers: {
    addApplication: (state, action: PayloadAction<Application>) => {
      state.applications = [...state.applications, action.payload];
    },
    updateApplication: (state, action: PayloadAction<Partial<Application>>) => {
      const { id, ...changes } = action.payload;
      state.applications = state.applications.map((application) =>
        application.id === id ? { ...application, ...changes } : application
      );
    },
    dropApplications: (state) => {
      state.applications = [];
      state.count = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicationsData.pending, (state) => {
        state.status = RequestStatus.Loading;
      })
      .addCase(
        fetchApplicationsData.fulfilled,
        (state, action: PayloadAction<ApplicationsList>) => {
          state.status = RequestStatus.Succeeded;
          state.applications = action.payload.content;
          state.count = action.payload.totalElements;
          state.error = null;
        }
      )
      .addCase(fetchApplicationsData.rejected, (state, action) => {
        state.status = RequestStatus.Failed;
        state.error = action.error.message || null;
      });
    builder
      .addCase(fetchAceApplicationsData.pending, (state) => {
        state.status = RequestStatus.Loading;
      })
      .addCase(
        fetchAceApplicationsData.fulfilled,
        (state, action: PayloadAction<ApplicationsList>) => {
          state.status = RequestStatus.Succeeded;
          state.applications = action.payload.content;
          state.count = action.payload.totalElements;
          state.error = null;
        }
      )
      .addCase(fetchAceApplicationsData.rejected, (state, action) => {
        state.status = RequestStatus.Failed;
        state.error = action.error.message || null;
      });
  }
});

export const { addApplication, updateApplication, dropApplications } =
  applicationsSlice.actions;

export default applicationsSlice.reducer;
